/* eslint-disable react/jsx-closing-tag-location, react/jsx-wrap-multilines */
import React, { useState, useRef, useEffect } from 'react';
import { connect, history } from 'umi';
import cl from 'classnames';
import { get } from 'lodash';
import { Text, Modal, Button, Divider } from '@digitalc/dxp-ui';
import { BaseSpin } from '@/components';
// import { CountDownInput } from '../components';
// import IMessage from '@/utils/IMessage';
import { onHistoryPush, numberFormat, getThemeImgByKey, dateFormat } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';
import { getDeviceType } from '@/utils/utilsPoint';
import { trackSensors } from '@/utils/sensors';
import Header from '../Header';
import styles from './index.less';

import errImg from '@/assets/images/point/offer_redeem_fail.png';
// import errImg from '@/assets/images/point/offer_redeem_fail_globe.png';
import successImg from '@/assets/images/point/offer_redeem_success.png';
// import defaultOfferImg from '@/assets/images/point/defaultOfferImg.png';

const OrderConfirmation = props => {
  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();

  const { loading = false, redeemPointsDXP, isWeb, isMulPoints, dxpToken, getSave } = props;
  // const [show, setShow] = useState(false);
  const [hasFail, setHasFail] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);
  // const [errMsg, setErrMsg] = useState('Network err, please try again later.');

  // const userInfo = get(props, 'location.state.userInfo');
  const skuListItem = get(props, 'location.state.skuListItem');
  const productListitem = get(props, 'location.state.productListitem');
  const effType = get(props, 'location.state.effType');
  const absEffDate = get(props, 'location.state.absEffDate');
  const category = get(props, 'location.state.category');
  const initAppStr = window.localStorage.getItem('initApp');
  const initApp = JSON.parse(initAppStr) || {};
  const loadingRef = useRef(null);

  useEffect(() => {
    trackSensors('reward_order_summary', {
      category,
      action: 'screen_view',
      product_name: productListitem?.name || '',
      productskuid: skuListItem?.skuCode || '',
    });
  }, []);

  const handleSubmitPointClick = () => {
    const redeemOffer = redeemPointsDXP;
    const payload = {
      prefix: initApp?.prefix,
      serviceNumber: initApp.phone,
      skuNbr: get(skuListItem, 'skuNbr'),
      productNbr: get(skuListItem, 'productNbr'),
    };
    if (effType) {
      payload.effType = effType;
    }
    if (absEffDate) {
      payload.absEffDate = dateFormat(absEffDate);
    }
    redeemOffer(payload).then(redeemPointsres => {
      // 验证成功或者失败都清空存在本地的time
      localStorage.removeItem('time');
      getSave({
        hasLengthRight: false,
        hasGetClick: false,
        hasTimeEnd: true,
      });
      if (get(redeemPointsres, 'code') === '200' && get(redeemPointsres, 'data')) {
        // 去兑换成功页面
        // setShow(false);
        // // setHasSuccess(true);
        // history.push({
        //   pathname: '/pointshop/successful',
        //   state: {
        //     serviceNumber: initApp.phone,
        //     goods: get(skuListItem, 'name'),
        //     pointValue: numberFormat(get(skuListItem, 'pointPriceDisplay')),
        //     pointType: get(skuListItem, 'pointAcctTypeName'),
        //   },
        // });
        trackSensors('reward_order_complete', {
          category,
          action: 'system_response',
          label: 'redemption - success',
          product_name: productListitem?.name || '',
          productskuid: skuListItem?.skuCode || '',
        });

        if (!isWeb) {
          history.push({
            pathname: '/pointshop/successfulNew',
          });
          return;
        }
        setHasSuccess(true);
        // getPointDetail({ });
      } else {
        trackSensors('reward_order_failed', {
          category,
          action: 'system_response',
          label: 'redemption - failed',
          product_name: productListitem?.name || '',
          productskuid: skuListItem?.skuCode || '',
        });

        // setErrMsg(redeemPointsres?.resultMsg);
        setHasFail(true);
      }
    });
  };

  const handleModalSubmit = () => {
    trackSensors('reward_order_summary', {
      category,
      action: 'button_click',
      label: 'redeem',
      product_name: productListitem?.name || '',
      productskuid: skuListItem?.skuCode || '',
    });
    handleSubmitPointClick();
  };

  const handleGoHome = () => {
    // 不使用桥接方法，桥接方法会打开一个新的容器，本地路由跳转即可
    onHistoryPush('/pointshop/pointsH5');
  };

  const handleTryClick = () => {
    setHasFail(false);
  };

  return (
    <div
      className={cl(styles.orderWrap, isWeb && styles.webOrderWrap, {
        [styles.androidOrderWrap]: getDeviceType() === 'android',
      })}
    >
      <Header
        title={GCPI18n({
          id: 'lb_header_order_confirmation',
        })}
        notNewPage
      />
      {/* <BaseSpin spinning={loading || modalLoading}> */}
      <BaseSpin spinning={loading}>
        <div className={styles.orderInfoBox} ref={loadingRef}>
          <div className={styles.prodInfo}>
            <div className={styles.infoImg}>
              <img
                src={get(skuListItem, 'thumbImage') || getThemeImgByKey('offerDefThumbnail')}
                alt=""
              />
            </div>
            <div className={styles.infoDetail}>
              <Text
                style={{ color: dxpToken.colorTextNeutral }}
                breakpoint="Mobile"
                size="ContentC15Bold"
              >
                {get(skuListItem, 'name')}
              </Text>
              <div className={styles.infoTip}>
                <Text
                  style={{ color: dxpToken.colorTextNeutral }}
                  breakpoint="Mobile"
                  size="ContentC14Regular"
                >
                  {numberFormat(get(skuListItem, 'pointPriceDisplay'))}
                </Text>
                <Text
                  style={{ color: dxpToken.colorTextNeutral, marginLeft: '0.03rem' }}
                  breakpoint="Mobile"
                  size="ContentC14Regular"
                >
                  {isMulPoints && get(skuListItem, 'pointAcctTypeName')
                    ? get(skuListItem, 'pointAcctTypeName')
                    : GCPI18n({ id: 'lb_data_offers_points' })}
                </Text>
                {/* {get(skuListItem, 'pointPriceDisplay')} {get(skuListItem, 'pointPrice') === 1 ? 'Point' : 'Points'} */}
              </div>
            </div>
          </div>

          <div
            className={styles.orderInfoBottom}
            style={{ padding: `${dxpToken.spacingGapMd / 100}rem 0rem` }}
          >
            <div className={styles.infoItem}>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                style={{ color: dxpToken.colorTextItemtitle }}
              >
                {GCPI18n({ id: 'lb_order_confirmation_quantity' })}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Bold"
                style={{ color: dxpToken.colorTextNeutral }}
              >
                1
              </Text>
              {/* <div className={styles.infoName}>{intl.formatMessage({ id: 'ORDER_CONFIRMATION_QUANTITY' })}</div>
              <div className={styles.infoValue}>1</div> */}
            </div>
            <div
              className={styles.infoItem}
              style={{ marginTop: `${dxpToken.spacingGapMd / 100}rem` }}
            >
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                style={{ color: dxpToken.colorTextItemtitle }}
              >
                {GCPI18n({ id: 'lb_order_confirmation_mobile_number' })}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Bold"
                style={{ color: dxpToken.colorTextNeutral }}
              >
                {get(JSON.parse(localStorage.getItem('initApp')), 'displayPhone') || '-'}
              </Text>
              {/* <div className={styles.infoName}>{intl.formatMessage({ id: 'ORDER_CONFIRMATION_SERVICE_NUMBER' })}</div>
              <div className={styles.infoValue}>{get(JSON.parse(localStorage.getItem('initApp')), 'phone')}</div> */}
            </div>
          </div>

          <Divider style={{ margin: `${dxpToken.spacingGapMd / 100}rem 0rem` }} />

          <Text
            breakpoint="Mobile"
            size="ContentC12Regular"
            style={{ color: dxpToken.colorTextSubtle }}
          >
            {GCPI18n({ id: 'lb_order_confirmation_message' })}
          </Text>
        </div>

        <div className={styles.orderFooter}>
          <div className={styles.pointWrap}>
            {/* {isMulPoints && get(skuListItem, 'pointAcctTypeName') && <Tag light types="grey" style={{ padding: '0.01rem 0.08rem', marginBottom: '0.04rem' }}>{get(skuListItem, 'pointAcctTypeName')}</Tag>} */}
            <Text
              breakpoint="Mobile"
              size="ContentC21Bold"
              style={{ color: dxpToken.colorTextAmount }}
            >{`${numberFormat(get(skuListItem, 'pointPriceDisplay'))} `}</Text>
            <Text
              breakpoint="Mobile"
              size="ContentC21Bold"
              style={{ color: dxpToken.colorTextAmount }}
            >
              {isMulPoints && get(skuListItem, 'pointAcctTypeName')
                ? get(skuListItem, 'pointAcctTypeName')
                : GCPI18n({ id: 'lb_converison_points' })}
            </Text>
            {/* <Amount showIcon>{initApp.currencyUnit}{numberFormat(get(skuListItem, 'pointPriceDisplay'))}</Amount>
            {
              get(skuListItem, 'pointAcctTypeName') && (
                <div className={styles.pointTypeName}>
                  <Text breakpoint="Mobile" size="ContentC12Bold">{get(skuListItem, 'pointAcctTypeName')}</Text>
                </div>
              )
            } */}
          </div>
          <Button type="primary" onClick={handleModalSubmit} className={styles.submitBtn}>
            {GCPI18n({
              id: 'lb_order_redeem',
            })}
          </Button>
          {/* <div className={styles.footerBox}>
            <div className={styles.orderPoint}>
              {get(skuListItem, 'pointPriceDisplay')} {get(skuListItem, 'pointPrice') === 1 ? 'Point' : 'Points'}
            </div>
            <div className={styles.orderSubmit}>
              <Button type="primary" onClick={handleModalSubmit} className={styles.submitBtn}>
                {GCPI18n({
                  id: 'ORDER_REDEEM',
                })}
              </Button>
            </div>
          </div> */}
        </div>
      </BaseSpin>

      {hasFail && isWeb && (
        <Modal
          breakpoint="desktop"
          size="50%"
          open={hasFail}
          onCancel={handleTryClick}
          maskClosable={false}
          className={styles.webPointsModal}
          // footer={<Button type="primary" onClick={handleTryClick}>{GCPI18n({ id: 'REDUCE_SUCCESS_BTN' })}</Button>}
          footer={
            <div style={{ display: 'flex', gap: '0.1rem' }}>
              <Button onClick={handleGoHome}>{GCPI18n({ id: 'lb_point_point_mall' })}</Button>
              <Button type="primary" onClick={handleTryClick} className={styles.primary}>
                {GCPI18n({ id: 'lb_dito_failed_page_try_again' })}
              </Button>
            </div>
          }
          // className={styles.pointsModal} open footer={null} centered closable={false}
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={getThemeImgByKey('genericWarning') || errImg} alt="" />
            </div>
            <Text
              breakpoint="Mobile"
              size="ContentC21Bold"
              style={{ marginBottom: '0.16rem', color: dxpToken.colorTextNeutral }}
            >
              {GCPI18n('lb_points_redeemed_again')}
            </Text>
          </div>
        </Modal>
      )}
      {hasFail && !isWeb && (
        <Modal
          breakpoint="mobile"
          size="50%"
          open={hasFail}
          onCancel={handleTryClick}
          // loading={modalLoading}
          className={styles.pointsModal}
          footer={
            <Button type="primary" onClick={handleTryClick}>
              {GCPI18n({ id: 'lb_order_redeem_fail' })}
            </Button>
          }
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={getThemeImgByKey('genericWarning') || errImg} alt="" />
            </div>
            <Text
              breakpoint="Mobile"
              size="TitleT23Bold"
              style={{ marginBottom: '0.16rem', color: dxpToken.colorTextNeutral }}
            >
              {GCPI18n({ id: 'lb_error_name' })}
            </Text>
            <Text
              style={{ color: dxpToken.colorTextNeutral }}
              breakpoint="Mobile"
              size="ContentC14Regular"
            >
              {GCPI18n({ id: 'lb_points_redeem_tip_temp' })}
            </Text>
          </div>
        </Modal>
      )}
      {hasSuccess && isWeb && (
        <Modal
          breakpoint="mobile"
          size="50%"
          open={hasSuccess}
          maskClosable={false}
          onCancel={() => setHasSuccess(false)}
          className={styles.webPointsModalSuccess}
          footer={
            <Button type="primary" onClick={handleGoHome}>
              {GCPI18n({ id: 'lb_points_redeem_success_awesome' })}
            </Button>
          }
          // className={styles.pointsModal} open footer={null} centered closable={false}
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={getThemeImgByKey('genericSuccess') || successImg} alt="" />
            </div>
            <Text breakpoint="Mobile" size="ContentC21Bold" style={{ marginBottom: '0.24rem' }}>
              {GCPI18n({ id: 'lb_successful_redeem_successful' })}
            </Text>
            <div className={styles.content}>
              <div className={styles.contentItem}>
                <div className={styles.contentTitle}>
                  {GCPI18n('lb_order_confirmation_service_number')}
                </div>
                <div className={styles.contentMessage}>{initApp.displayPhone}</div>
              </div>

              <div className={styles.contentItem}>
                <div className={styles.contentTitle}>{GCPI18n('lb_points_goods')}</div>
                <div className={styles.contentMessage}>{get(skuListItem, 'name')}</div>
              </div>

              <div className={styles.contentItem}>
                <div className={styles.contentTitle}>{GCPI18n('lb_transfer_type')}</div>
                <div className={styles.contentMessage}>{get(skuListItem, 'pointAcctTypeName')}</div>
              </div>

              <div className={styles.contentItem}>
                <div className={styles.contentTitle}>{GCPI18n('lb_point')}</div>
                <div className={styles.contentMessage}>
                  {numberFormat(get(skuListItem, 'pointPriceDisplay'))}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {hasSuccess && !isWeb && (
        <Modal
          breakpoint="mobile"
          size="50%"
          open={hasSuccess}
          onCancel={() => setHasSuccess(false)}
          className={styles.pointsModal}
          footer={
            <Button type="primary" onClick={handleGoHome}>
              {GCPI18n({ id: 'lb_points_redeem_success_awesome' })}
            </Button>
          }
          // className={styles.pointsModal} open footer={null} centered closable={false}
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={getThemeImgByKey('genericSuccess') || successImg} alt="" />
            </div>
            <Text breakpoint="Mobile" size="TitleT23Bold" style={{ marginBottom: '0.16rem' }}>
              {GCPI18n({ id: 'lb_successful_redeem_successful' })}
            </Text>
            <Text breakpoint="Mobile" size="ContentC14Regular">
              {GCPI18n({ id: 'lb_points_redeem_success_tip' })}
            </Text>
          </div>
        </Modal>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  redeemPointsDXP: payload =>
    dispatch({
      type: 'pointShop/redeemPointsDXP',
      payload,
    }),
  getSave: payload =>
    dispatch({
      type: 'pointShop/updateState',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading, index }) => ({
    smsCode: pointShop.smsCode,
    hasLengthRight: pointShop.hasLengthRight,
    hasGetClick: pointShop.hasGetClick,
    hasTimeEnd: pointShop.hasTimeEnd,
    isWeb: index.isWeb,
    isMulPoints: index.isMulPoints,
    dxpToken: index.dxpToken,
    loading: loading.effects['pointShop/redeemPointsDXP'] || false,
  }),
  mapDispatchToProps,
)(OrderConfirmation);
